import type { MeetingPrepSummaryMetadata } from "../store/schema/MeetingPrepSummaryMetadata";

export function checkSummaryWorthy(summaryWorthyMetadata: MeetingPrepSummaryMetadata | undefined): boolean {
    if (!summaryWorthyMetadata) {
        return false;
    }
    return (summaryWorthyMetadata.chats > 0 ||
        summaryWorthyMetadata.files > 0 ||
        summaryWorthyMetadata.emails > 0 ||
        summaryWorthyMetadata.recaps > 0);
}
